module.exports = __webpack_public_path__ + "img/play-store-badge.f8475641.png";